import { LEARN_TUTORIAL_SIMULATION_RESULTS } from '../constants';

const idToUrlAnchorMap: Record<string, string> = {
  sharpe: 'sharpe-and-ir',
  turnover: 'is-summary',
  fitness: 'fitness',
  returns: 'return',
  drawdown: 'is-summary',
  margin: 'is-summary',
} as const;

export function getTutorialUrl(columnId?: string) {
  if (columnId && columnId in idToUrlAnchorMap) {
    return `${LEARN_TUTORIAL_SIMULATION_RESULTS}#${idToUrlAnchorMap[columnId]}`;
  }
  return LEARN_TUTORIAL_SIMULATION_RESULTS;
}
